import React from 'react';

import { StyleUtil } from '../../util';
import classNames from './EABDTallButton.module.scss';

type TallButtonType = 'primary' | 'secondary' | 'tertiary' | 'quaternary';

export interface TallButtonProps
  extends Readonly<{
    children?: React.ReactNode;
    type: TallButtonType;
    isFilled: boolean;
    onPress: () => void;
  }> {}

export const TallButton = React.memo<TallButtonProps>((props) => {
  const { children, type, isFilled, onPress } = props;

  const ButtonClassNames = React.useMemo(() => {
    const buttonClassNames: string[] = [classNames.button];

    switch (type) {
      case 'primary':
        buttonClassNames.push(classNames.primary);
        break;
      case 'secondary':
        buttonClassNames.push(classNames.secondary);
        break;
      case 'tertiary':
        buttonClassNames.push(classNames.tertiary);
        break;
      case 'quaternary':
        buttonClassNames.push(classNames.quaternary);
        break;
    }

    if (isFilled) {
      buttonClassNames.push(classNames.filled);
    }

    return StyleUtil.mergeClassNames(buttonClassNames);
  }, [type, isFilled]);

  return (
    <button onClick={onPress} className={ButtonClassNames}>
      {children}
    </button>
  );
});
